export default __webpack_public_path__ + "static/media/Lior.f18ef3e5.jpg";